<template>
  <v-autocomplete
    label="Proyectos"
    placeholder="Seleccione un proyecto"
    :loading="loading"
    :items="items"
    item-text="_label"
    item-value="code"
    return-object
    v-bind:value="value"
    :rules="onlyRequired"
    v-on:input="$emit('input', $event)"
    :search-input.sync="search"
    ref="auto"
  >
  </v-autocomplete>
</template>

<script>
import requests from "@/services/requests";
import rules from "@/utils/form.rules";
export default {
  props: {
    reset: { type: Boolean, required: false },
    value: [Object],
    reload: [Boolean],
  },
  data: () => ({
    loading: true,
    items: [],
    onlyRequired: [rules.required],
    search: "",
  }),
  methods: {
    getProjects(param = "") {
      this.loading = true;
      let uri = "/api/project/projects/?search=";
      if (this.search) {
        uri += param;
      }
      requests.get(uri).then((res) => {
        if (res.status == 200) {
          this.items = res.data;
          this.loading = false;
        } else {
          console.log(res);
        }
      });
    },
  },
  watch: {
    reset: function () {
      this.$refs.auto.reset();
    },
    reload: function () {
      this.getProjects();
    },
    search: function () {
      this.getProjects(this.search);
    },
  },
  mounted() {
    this.getProjects();
  },
};
</script>
